import Vue from 'vue/dist/vue.min.js';
import VModal from 'vue-js-modal';
import {videoModal} from './modals';

const VideoPlayerLink = () => {

    let videos = document.querySelectorAll('.video-player-link');
    Vue.use(VModal);

    let VideoConstructor = (id) => {
        Vue.component('video-player-template-link', {
            data: function() {
                return {
                    videoUrl: '',
                    videoName: null
                }
            },
            methods: {
                launchVideo() {
                    this.$modal.show(
                        videoModal.template(this.videoUrl, this.videoName),
                        videoModal.name,
                        videoModal.options
                    )
                }
            } ,
            mounted() {
                this.videoUrl = this.$refs.overlay.dataset.videoId;
                this.videoName =  null;
            }
        });
    
        new Vue({
            el: `.video-player-link-${id}`,
        }).$mount(`.video-player-link-${id}`, true);
    }

    if (videos.length > 0) {
        videos.forEach((item, index) => {
            item.classList.add(`video-player-link-${index}`);
            VideoConstructor(index);
        })
    }
}

export default VideoPlayerLink;